import type { ThirdPartyPlugin } from '../types';
import { promisifyLoad } from '../utils';
import { setup, load } from './script';
import type { TTQ } from './types';

declare global {
  interface Window {
    /**
     * @description TikTok pixel global instance. Currently all methods have ...any[] arguments because of unknown types.
     * @see [tiktok-docs](https://ads.tiktok.com/help/article?aid=10021)
     */
    ttq: TTQ;
  }
}

const config = {
  id: process.env.isProduction ? 'C8PQO6DH2V1MUSDNLQK0' : 'C5DHNOVGE0M3SF4IEGOG',
};

const tikTokPlugin: ThirdPartyPlugin = () => {
  setup();

  return {
    entry: window.ttq,
    load: promisifyLoad(load, config),
    // isInitialized: isInitialized.bind(null, config),
  };
};

export default tikTokPlugin;
